import accessControl from "./accessControl/accessControl.middleware";
import reduxClean from "./reduxClean/reduxClean.middleware";

export default [accessControl, reduxClean];
